import React from 'react';

const CopyIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        fill="none"
        d="M13 4.714V4a3 3 0 00-3-3H4a3 3 0 00-3 3v7a3 3 0 003 3h2m8 9h6a3 3 0 003-3v-7a3 3 0 00-3-3h-6a3 3 0 00-3 3v7a3 3 0 003 3z"
      ></path>
    </svg>
  );
};

export default CopyIcon;
